import api from "../../../index";

// Create copilotChat
export const createCopilotChat = async (data: any) => {
  return await api.post("/copilot-chat", data);
};

// Get all getAllCopilotChats
export const getAllCopilotChats = async () => {
  return await api.get("/copilot-chats");
};

// Get all copilot chats paginated search
export const getAllCopilotChatsPaginatedSearch = async (
  page: any,
  perPage: any,
  searchText: any
) => {
  if (!searchText) {
    return await api.get(
      `/copilot-chats/paginated/search?page=${page}&perPage=${perPage}`
    );
  } else {
    return await api.get(
      `/copilot-chats/paginated/search?page=${page}&perPage=${perPage}&searchText=${searchText}`
    );
  }
};

// Get copilotChat by id
export const getCopilotChatById = async (id: any) => {
  return await api.get(`/copilot-chat/${id}`);
};

// Update copilotChat by id
export const updateCopilotChatById = async (id: any, data: any) => {
  return await api.put(`/copilot-chat/${id}`, data);
};

// Delete copilotChat by id
export const deleteCopilotChatById = async (id: any) => {
  return await api.delete(`/copilot-chat/${id}`);
};

// Upload copilotChat image
export const uploadCopilotChatImage = async (values: any, config: any) => {
  return await api.post("/copilot-chat/image", values, config);
};

// Seed default templates
export const seedDefaultCopilotChats = async (force: boolean = false) => {
  return await api.post("/copilot-chats/seed", { force });
};

// Check seed status
export const checkCopilotChatsSeedStatus = async () => {
  return await api.get("/copilot-chats/seed/status");
};
